import React from 'react';
import { Bot, Play, Settings } from 'lucide-react';

const AgentCard = ({ agent, onTestCall, t }) => (
  <div className="bg-[#1a1a1f] border border-gray-700 rounded-xl p-5 hover:border-gray-600 transition-colors">
    <div className="flex items-start justify-between mb-3">
      <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center">
        <Bot className="w-6 h-6 text-white" />
      </div>
      <span className={`px-2 py-1 rounded text-xs font-medium ${
        agent.status === 'active' ? 'bg-green-400/10 text-green-400' : 'bg-gray-400/10 text-gray-400'
      }`}>
        {agent.status}
      </span>
    </div>
    <h3 className="text-white font-semibold mb-1">{agent.name}</h3>
    <p className="text-gray-500 text-sm mb-4 line-clamp-2">{agent.description || agent.greeting}</p>
    <div className="flex gap-2">
      <button
        onClick={() => onTestCall(agent)}
        className="flex-1 flex items-center justify-center gap-2 bg-teal-400/10 hover:bg-teal-400/20 text-teal-400 py-2 rounded-lg text-sm font-medium transition-colors"
        data-testid={`test-call-btn-${agent.id}`}
      >
        <Play className="w-4 h-4" />
        {t('userDashboard.testCall')}
      </button>
      <button
        className="p-2 bg-gray-700/50 hover:bg-gray-700 rounded-lg transition-colors"
        data-testid={`agent-settings-btn-${agent.id}`}
        aria-label="Agent settings"
      >
        <Settings className="w-4 h-4 text-gray-400" />
      </button>
    </div>
  </div>
);

export const VoiceAgentsList = ({ agents, onTestCall, t }) => (
  <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-6 mb-8" data-testid="voice-agents-list">
    <div className="flex items-center justify-between mb-6">
      <h2 className="text-lg font-semibold text-white">{t('userDashboard.voiceAgents')}</h2>
    </div>

    {agents.length === 0 ? (
      <div className="text-center py-12" data-testid="voice-agents-empty">
        <Bot className="w-16 h-16 text-gray-600 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-400 mb-2">{t('userDashboard.noAgentsAssigned')}</h3>
        <p className="text-gray-500 text-sm">{t('userDashboard.contactAdmin')}</p>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {agents.map((agent) => (
          <AgentCard key={agent.id} agent={agent} onTestCall={onTestCall} t={t} />
        ))}
      </div>
    )}
  </div>
);
